/* istanbul ignore file */
import { supportedBrands } from 'utils/constants';

// Declaration
declare global {
  var __env__: {
    ENV: string;
    MAVENOID_ORG_NAME: string;
    MAVENOID_CLIENT_ID: string;
    KEYLIGHT_URL: string;
    KEYLIGHT_ORDER_KEY: string;
    SENTRY_DSN: string;
    BACKEND_API: string;
    AUTH_URL: string;
    AUTH_CLIENT_ID: string;
    BRAND: string;
    DISABLE_PRODUCT_REGISTRATION?: string;
  };
  var SENTRY_RELEASE:
    | {
        id?: string;
      }
    | undefined;
  var __REDUX_DEVTOOLS_EXTENSION__: () => any;
  var mavenoid: any;
  var dataLayer: Array<Record<string, unknown>> | undefined;
}

// Variables
export const environment = globalThis.__env__.ENV;
export const keylightUrl = globalThis.__env__.KEYLIGHT_URL;
export const keylightOrderKey = globalThis.__env__.KEYLIGHT_ORDER_KEY;
export const sentryDsn = globalThis.__env__.SENTRY_DSN;
export const sentryRelease = globalThis.SENTRY_RELEASE?.id;
export const mavenoidClientId = globalThis.__env__.MAVENOID_CLIENT_ID;
export const mavenoidOrgName = globalThis.__env__.MAVENOID_ORG_NAME;
export const backendApi = globalThis.__env__.BACKEND_API;
export const authUrl = globalThis.__env__.AUTH_URL;
export const authClientId = globalThis.__env__.AUTH_CLIENT_ID;
export const brand = globalThis.__env__.BRAND;
export const disableProductRegistration =
  globalThis.__env__.DISABLE_PRODUCT_REGISTRATION === 'true';

// Validations
if (!backendApi) {
  throw new Error('Backend endpoint not set! Application will not work!');
}

if (!brand) {
  throw new Error('Brand not set! Application will not work!');
}

if (!supportedBrands.includes(brand)) {
  throw new Error(
    `Brand '${brand}' is not supported! Must be one of: ${supportedBrands.join(', ')}`
  );
}

// Checks
export const isConstruction = brand === 'construction';
export const isHusqvarna = brand === 'husqvarna';
export const isTest = environment === 'test';
export const isDev = environment === 'dev';
export const isLive = environment === 'live';
